import React, { useCallback } from 'react'
import List from '@commonComponents/List'
import AdditionalDocForm from '@EUForms/additionalDocForm'
import { useDispatch, useSelector } from 'react-redux'
import { selectAdditionalRefTypeList } from '@EUForms/selectors'
import CopyRepElement from '@commonComponents/copyRepElement'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import  validate  from 'validate.js'
import { updateValidationErrors } from '../../reducer/validationSlice'
import { useTranslation } from '@hooks/useTranslation'

const AdditionalDocDetail = ({ dataSource,fieldPattern,createRepElemMsgStructure,invoiceIndex,itemIndex, ...rest }) => {
  const dispatch = useDispatch()
  const translate = useTranslation()
  const { additionalDocumentsList } = fieldPattern()?.itemsTab
  const dropdownList = useSelector(selectAdditionalRefTypeList)
  const {isDisabled} = useCurrentShipmentType()


  const additionalDocValidarion = (addDocIdx,name,value) =>{
 
   const key = `invoice${invoiceIndex+1}_lineItem${itemIndex+1}_ADDITIONAL_DOCUMENT${addDocIdx+1}_${name}`   
   
    let repElemErr = validate({[name]:value},
      {[name]:additionalDocumentsList[name]}
    ) || {}
 
    repElemErr = createRepElemMsgStructure(repElemErr,"ADDITIONAL_DOCUMENT", invoiceIndex, itemIndex, addDocIdx,translate)

    dispatch(updateValidationErrors({
      tabName: 'itemsTab',
      errors: {...repElemErr},
      errorKeys: [key]
  }))
  }

  const renderItem = useCallback(
    ({id, ...restItem},addDocIdx) => (
      <AdditionalDocForm 
        key={id} 
        dataSource={{id, ...restItem}}
        isDisabled={isDisabled} 
        copyDocument={(translate) => (<CopyRepElement
          translate={translate}
          title='ADDITIONAL_DOCUMENT'
          request={{id, ...restItem, infoType:'EU_ADDITIONAL_DOCUMENT'}}
          callback={rest?.copyData}
          isFormDisabled={isDisabled}
          tableName={rest?.tableName}
          />)}
        docTypeList={dropdownList} 
        addDocIdx={addDocIdx}
        additionalDocValidarion={additionalDocValidarion}
        {...rest} 
      />
    ),
    [dropdownList,translate]
  )

  return <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(AdditionalDocDetail)
